import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { Role } from 'src/app/models/role.model';
import { SurveyFilter } from 'src/app/models/survey.model';
import { SurveyVariableConditionFilterDirectionEnum } from 'src/app/enums/survey-variable-condition-filter-direction.enum';

@Component({
  selector: 'app-targeted-roles-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './targeted-roles-card.component.html',
  styleUrl: './targeted-roles-card.component.css',
  host: { '[attr.title]': 'null' },
  imports: [MatCheckboxModule, MatDividerModule],
})
export class TargetedRolesCardComponent {
  readonly title = input('Roles');
  readonly description = input<string | null>(null);
  readonly all_label = input('Todos');
  readonly embedded = input(false);
  readonly error_message = input<string | null>(null);
  readonly options = input.required<Role[]>();
  readonly selection = model.required<number[]>();

  protected readonly selected_ids_set = computed(() => new Set(this.selection()));

  protected readonly all_selected = computed((): boolean => {
    const options = this.options();

    if (options.length === 0) {
      return false;
    }

    const selected_ids = this.selected_ids_set();

    return options.every(option => selected_ids.has(option.id));
  });

  protected onAllChange(checked: boolean): void {
    this.selection.set(checked ? this.options().map(option => option.id) : []);
  }

  protected onOptionChange(option_id: number, checked: boolean): void {
    const selected_ids = new Set(this.selection());

    if (checked) {
      selected_ids.add(option_id);
    } else {
      selected_ids.delete(option_id);
    }

    this.selection.set([...selected_ids]);
  }
}

export function getToAnswerRoleIds(filters: SurveyFilter[], roles: Role[]): number[] {
  const filter = filters.find(filter => filter.direction === SurveyVariableConditionFilterDirectionEnum.ToAnswer);
  return filter ? filter.roles.map(role => role.id) : roles.map(role => role.id);
}

export function setTargetedRoleSelection(control: FormControl<number[]>, role_ids: number[]): void {
  control.setValue(role_ids);
  control.markAsDirty();
  control.markAsTouched();
}
